(function(){
  var STORAGE_KEY = 'dmc_reseller_checklist_v1';
  var AI_ENDPOINT = window.RLP_AI_ENDPOINT || '';
  var CORE_STEPS = ['account','plan','whatsapp','minishop','invoice','ads'];

  function loadState(){
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch(e){ return {}; }
  }
  function saveState(state){
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch(e){}
  }

  var state = loadState();

  var params = new URLSearchParams(window.location.search);
  if (params.get('opened') === '1') { state.account = true; saveState(state); }

  function renderStamps(){
    document.querySelectorAll('.rlp-page').forEach(function(page){
      var step = page.getAttribute('data-step');
      page.classList.toggle('is-done', !!state[step]);
    });
    var doneCore = CORE_STEPS.filter(function(s){ return state[s]; }).length;
    var pct = Math.round((doneCore / CORE_STEPS.length) * 100);
    document.getElementById('rlp-progress-num').textContent = pct;
    document.getElementById('rlp-progress-bar').style.width = pct + '%';
    document.getElementById('rlp-reward').hidden = pct < 100;
  }

  document.querySelectorAll('[data-mark]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var step = btn.getAttribute('data-mark');
      state[step] = !state[step];
      saveState(state);
      renderStamps();
    });
  });

  document.getElementById('rlp-reset').addEventListener('click', function(){
    if (!confirm('Reset your checklist progress? This only clears this browser.')) return;
    state = {};
    saveState(state);
    renderStamps();
  });

  renderStamps();

  var PLAN_GOALS = {
    steady: 'a steady side income without it taking over your week',
    fulltime: 'growing this into full-time income',
    stock: 'moving stock fast through people you already know',
    test: 'testing the waters before committing more time'
  };
  var PLAN_CHANNELS = {
    facebook: {
      name: 'Facebook groups and Marketplace',
      tips: ['Join 5-10 local buy/sell groups and post 2-3 items a week, not your whole catalogue at once.', 'Marketplace listings with clear pricing outperform "DM for price" every time.', 'Reply to comments fast — Facebook favours posts with early engagement.', 'Use the ad images from your product pages so listings look professional from day one.']
    },
    whatsapp: {
      name: 'WhatsApp broadcasts and status',
      tips: ['Build one broadcast list, not ten separate groups — easier to manage, less spammy.', 'Post to your status 3-4 times a week with real photos, not stock images.', 'Always include your invoice link so people can order in one tap.', 'Pin your best-selling item to the top of chats so it\'s the first thing repeat customers see.']
    },
    instagram: {
      name: 'Instagram',
      tips: ['Short unboxing or demo clips outperform static product photos.', 'Use 3-5 relevant hashtags, not thirty — quality over quantity.', 'Pin your best-selling product to the top of your profile.', 'Use Stories for daily reach and your grid for the products you want to be found for later.']
    },
    tiktok: {
      name: 'TikTok',
      tips: ['Post consistently — 3-4 short clips a week beats one polished video a month.', 'Show the product in use, not just sitting on a table.', 'Reply to every comment in the first hour — it tells the algorithm the post is worth pushing.', 'Link your MiniShop in bio so viewers have somewhere to actually buy.']
    },
    inperson: {
      name: 'in-person and word of mouth',
      tips: ['Carry a small physical price list or catalogue printout for spontaneous conversations.', 'Ask happy customers directly for a referral — most people won\'t offer unprompted.', 'A simple loyalty perk (referral discount) goes a long way in person.', 'Keep a WhatsApp broadcast for regulars so in-person contacts turn into repeat online orders.']
    },
    minishop: {
      name: 'your MiniShop as the hub',
      tips: ['Treat your MiniShop as the destination — drive traffic to it from every other channel.', 'Keep your MiniShop link in every bio, status, and post so it\'s always one tap away.', 'Update it regularly so it never looks abandoned — even small tweaks signal you\'re active.', 'Share it directly rather than individual product links, so people browse your whole range.']
    }
  };
  var PLAN_TIME = {
    low: 'With under 5 hours a week, keep it simple — pick ONE channel from above and post consistently rather than spreading thin across several.',
    mid: 'With 5-15 hours a week, you can run one main channel well and use a second to top up reach — don\'t try to be everywhere at once.',
    high: 'With 15+ hours a week, you can run multiple channels properly — just make sure each one gets real attention rather than a rushed cross-post.'
  };
  var planBtn = document.getElementById('rlp-plan-generate');
  if (planBtn) planBtn.addEventListener('click', function(){
    var goal = document.getElementById('rlp-plan-goal').value;
    var channel = document.getElementById('rlp-plan-channel').value;
    var time = document.getElementById('rlp-plan-time').value;
    var out = document.getElementById('rlp-plan-output');
    var c = PLAN_CHANNELS[channel];
    out.innerHTML = '<h4>Your starting plan</h4>' +
      '<p>Your main focus: <strong>' + PLAN_GOALS[goal] + '</strong>, mainly through <strong>' + c.name + '</strong>.</p>' +
      '<ul style="margin:.5rem 0 1rem;padding-left:1.1rem">' + c.tips.map(function(t){ return '<li style="margin-bottom:.35rem">' + t + '</li>'; }).join('') + '</ul>' +
      '<p style="margin:0"><strong>On your time budget:</strong> ' + PLAN_TIME[time] + '</p>';
    out.hidden = false;
    state.plan = true; saveState(state); renderStamps();
  });

  function callAI(payload, outEl, onSuccess){
    if (!AI_ENDPOINT) {
      outEl.innerHTML = '<p class="rlp-tool__note">This tool isn\'t connected yet — ask DuMey Webworks to finish hooking up the AI backend.</p>';
      outEl.hidden = false;
      return;
    }
    outEl.innerHTML = '<p class="rlp-tool__note">Thinking…</p>';
    outEl.hidden = false;
    fetch(AI_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(r){
      if (!r.ok) throw new Error('Request failed');
      return r.json();
    }).then(function(data){
      onSuccess(data);
    }).catch(function(){
      outEl.innerHTML = '<p class="rlp-tool__note">Couldn\'t reach the AI tool right now. Try again in a moment.</p>';
    });
  }

  function copyText(text, btn){
    navigator.clipboard.writeText(text).then(function(){
      var original = btn.textContent;
      btn.textContent = 'Copied';
      setTimeout(function(){ btn.textContent = original; }, 1500);
    });
  }

  var nameBtn = document.getElementById('rlp-name-generate');
  if (nameBtn) nameBtn.addEventListener('click', function(){
    var desc = document.getElementById('rlp-name-input').value.trim();
    var out = document.getElementById('rlp-name-output');
    if (!desc) { out.innerHTML = '<p class="rlp-tool__note">Add a short description first.</p>'; out.hidden = false; return; }
    callAI({ type: 'name', description: desc }, out, function(data){
      var names = data.results || [];
      out.innerHTML = '<h4>A few options</h4><div>' +
        names.map(function(n){ return '<span class="rlp-name-chip">' + n + '</span>'; }).join('') +
        '</div>';
      state.name = true; saveState(state); renderStamps();
    });
  });

  var termsBtn = document.getElementById('rlp-terms-generate');
  if (termsBtn) termsBtn.addEventListener('click', function(){
    var name = document.getElementById('rlp-terms-name').value.trim();
    var payment = document.getElementById('rlp-terms-payment').value;
    var returns = document.getElementById('rlp-terms-returns').value;
    var out = document.getElementById('rlp-terms-output');
    if (!name) { out.innerHTML = '<p class="rlp-tool__note">Add your business name first.</p>'; out.hidden = false; return; }
    callAI({ type: 'terms', businessName: name, payment: payment, returns: returns }, out, function(data){
      out.innerHTML = '<h4>Full terms</h4><div id="rlp-terms-full" style="white-space:pre-wrap">' + data.full + '</div>' +
        '<button type="button" class="rlp-btn rlp-btn--ghost rlp-copy" id="rlp-copy-full">Copy full terms</button>' +
        '<h4 style="margin-top:1rem">WhatsApp summary</h4><div id="rlp-terms-summary" style="white-space:pre-wrap">' + data.summary + '</div>' +
        '<button type="button" class="rlp-btn rlp-btn--ghost rlp-copy" id="rlp-copy-summary">Copy summary</button>' +
        '<button type="button" class="rlp-btn rlp-btn--text rlp-copy" id="rlp-print-terms">Print / save as PDF</button>';
      document.getElementById('rlp-copy-full').addEventListener('click', function(){ copyText(data.full, this); });
      document.getElementById('rlp-copy-summary').addEventListener('click', function(){ copyText(data.summary, this); });
      document.getElementById('rlp-print-terms').addEventListener('click', function(){ window.print(); });
      state.terms = true; saveState(state); renderStamps();
    });
  });
})();
